import React from 'react';

export default function SignOut({ className = '', title }) {
  return (

   <svg
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g opacity="0.01">
        <rect
          width="0.75"
          height="0.75"
          transform="translate(16.5 9)"
          fill="currentColor"
        />
      </g>
      <path
        d="M6.34961 1.5H1.5V16.5H6.75V18H0V0H6.34961V1.5Z"
        fill="currentColor"
      />
      <path
        d="M17.7803 8.46973C18.0716 8.7611 18.0734 9.23287 17.7842 9.52637L13.3486 14.0264L12.2803 12.9736L15.458 9.75H4.5V8.25H15.4395L12.2197 5.03027L13.2803 3.96973L17.7803 8.46973Z"
        fill="currentColor"
      />
    </svg>

  );
}

